import styles from './DepthContours.module.css';

/*
 * WhaleTail's one decorative flourish: faint bathymetric contour lines, the
 * kind a sea chart uses to mark depth, sitting behind the headline number.
 * Purely ornamental (aria-hidden) and generated once at module load from a
 * fixed formula, so it's identical on every render and needs no assets.
 */

const RINGS = 9;
const STEPS = 72;

function ring(index: number): string {
  const base = 26 + index * 15;
  const points: string[] = [];
  for (let s = 0; s <= STEPS; s++) {
    const a = (s / STEPS) * Math.PI * 2;
    const wobble =
      Math.sin(a * 3 + index * 0.55) * (3 + index * 0.9) +
      Math.cos(a * 5 - index * 0.35) * (1.5 + index * 0.4);
    const r = base + wobble;
    // Slightly wider than tall, like a seamount seen from above.
    const x = 320 + Math.cos(a) * r * 1.35;
    const y = 70 + Math.sin(a) * r;
    points.push(`${s === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`);
  }
  return `${points.join(' ')} Z`;
}

const PATHS = Array.from({ length: RINGS }, (_, i) => ring(i));

export function DepthContours() {
  return (
    <svg
      className={styles.contours}
      viewBox="0 0 400 220"
      preserveAspectRatio="xMaxYMin slice"
      aria-hidden="true"
      focusable="false"
    >
      {PATHS.map((d, i) => (
        <path key={i} d={d} strokeOpacity={(1 - i / (RINGS + 2)).toFixed(2)} />
      ))}
    </svg>
  );
}
